import { SelectionBaseT } from 'business/definitions';
import { getParent } from 'helpers/treeHelpers';

/**
 * We want to display a chip for a resource if it is not a child of a selected resource. This helpers identify a child with a selected parent.
 * @param tree - the tree of the resource
 * @param selectedValues - the selected values
 * @param resource - the resource to check
 * @returns {boolean} - true if the resource is a child and its parent is selected, false otherwise
 */
export const getIsParentSelected = (
    tree: TreeT | null,
    selectedValues: SelectionBaseT[],
    resource: SelectionBaseT,
) => {
    const resourceParent = tree ? getParent(tree, resource.value) : undefined;
    const isParentSelected =
        resourceParent &&
        selectedValues
            .map((selected) => selected.value)
            .includes(resourceParent.value);

    return isParentSelected;
};
